import http_request from './http_request'
import config from 'config'

function getCredentials(jwt) {
	const headers = {
		SUBTYPE: 'html',
		NPVERSION: '999.999.999',
		JWT: jwt,
	}

	return http_request
		.get(`${config.api}immersive_reader`)
		.withHeaders(headers)
		.send()
}

export default {
	getCredentials,
}
